if (!customElements.get('reveal-text')) {
  class RevealText extends HTMLElement {
    constructor() {
      super();
      this.isIntersecting = false;
      this.ticking = false;
    }

    connectedCallback() {
      this.init();
      
      // Global listeners
      this.onScroll = () => {
        if (!this.ticking) {
          window.requestAnimationFrame(() => {
            this.handleScroll();
            this.ticking = false;
          });
          this.ticking = true;
        }
      };
      
      this.onResize = () => this.handleScroll();
      
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize);
      
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          this.isIntersecting = entry.isIntersecting;
          if (this.isIntersecting) this.handleScroll();
        });
      }, { rootMargin: '10%', threshold: 0 });
      
      this.observer.observe(this);

      // Shopify Editor Support
      document.addEventListener('shopify:section:load', (event) => {
        const id = this.closest('.shopify-section')?.id.replace('shopify-section-', '');
        if (event.detail.sectionId === id) this.init();
      });

      this.handleScroll();
    }

    init() {
      this.revealElement = this.querySelector('[data-js-reveal-text]');
      if (!this.revealElement) return;
      this.splitWords();
      this.handleScroll();
    }

    splitWords() {
      if (!this.revealElement) return;
      const text = this.revealElement.textContent.trim();
      const words = text.split(/\s+/);
      
      // Clear and rebuild to avoid double splitting
      this.revealElement.innerHTML = '';
      words.forEach(word => {
        const span = document.createElement('span');
        span.className = 'reveal-word';
        span.textContent = word;
        this.revealElement.appendChild(span);
        this.revealElement.appendChild(document.createTextNode(' '));
      });
      
      this.words = this.querySelectorAll('.reveal-word');
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      if (this.observer) this.observer.disconnect();
    }

    handleScroll() {
      if (!this.isIntersecting && !Shopify.designMode) return;

      const rect = this.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      
      const totalScrollable = rect.height - viewportHeight;
      const currentScroll = -rect.top;
      
      let overallProgress = (currentScroll / totalScrollable) * 100;
      overallProgress = Math.min(100, Math.max(0, overallProgress));

      if (this.words && this.words.length > 0) {
        const totalWords = this.words.length;
        this.words.forEach((word, index) => {
          const wordStart = (index / totalWords) * 100;
          const wordEnd = ((index + 1) / totalWords) * 100;
          
          let wordProgress = (overallProgress - wordStart) / (wordEnd - wordStart);
          wordProgress = Math.min(100, Math.max(0, wordProgress * 100));
          
          word.style.setProperty('--word-reveal', `${wordProgress}%`);
        });
      }
    }
  }
  customElements.define('reveal-text', RevealText);
}
